/**
 * Single source of truth for the API base URL.
 *
 * A `window.__PIRX_API_BASE_URL__` override (set by e2e/dev tooling) wins over
 * the build-time `VITE_API_BASE_URL`, which in turn wins over the local
 * default. Every caller must go through here so overrides apply uniformly.
 */

const DEFAULT_API_BASE_URL = "http://localhost:8000/api";

export function getApiBaseUrl(): string {
  if (typeof window !== "undefined") {
    const override = (window as Window & { __PIRX_API_BASE_URL__?: string })
      .__PIRX_API_BASE_URL__;
    if (override) {
      return override;
    }
  }

  const envApiBaseUrl: unknown = import.meta.env.VITE_API_BASE_URL;
  return typeof envApiBaseUrl === "string" && envApiBaseUrl.length > 0
    ? envApiBaseUrl
    : DEFAULT_API_BASE_URL;
}

export const API_BASE_URL = getApiBaseUrl();
